import { render, staticRenderFns } from "./couponDisplay.vue?vue&type=template&id=4685948a&lang=pug"
import script from "./couponDisplay.vue?vue&type=script&lang=coffee"
export * from "./couponDisplay.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports